events = require('events')
io = require('socket.io-client')
config = 
  'iceServers': [
    {'url': 'stun:stun.l.google.com:19302'}
  ]

class Peer extends events.EventEmitter
  constructor: (@socket, @iceServers)->      
    @init()

  init: ()->       
    @pc?.close()    
    @channel?.close()
    @pc = new RTCPeerConnection({"iceServers": @iceServers})        
    # @pc = new RTCPeerConnection(config) 
    @pc.onicecandidate = (evt)=>      
      console.log(evt.candidate)
      if evt?.candidate 
        @negotiate('candidate', evt.candidate)      
    @pc.onicecandidateerror = (e)=>
      if e
        console.log e
    @pc.onconnectionstatechange = (e) =>
      if e
        console.log "on connection state change"
        console.log e
    @pc.oniceconnectionstatechange = (e) =>
      if e
        console.log "on ice connection state change"
        console.log e
    @pc.onicegatheringstatechange  = (e) =>
      if e
        console.log "on ice gathering state change"
        console.log e
    @pc.onnegotiationneeded = (e) =>
      if e
        console.log "on negotiated"
        console.log e
    @pc.onaddstream = (event)=> 
      @emit("stream", event.stream)

    @channel = @pc.createDataChannel('data');  
    @channel.onopen = ()=>
      state = @channel.readyState;
      console.log("ReadyState: " + state)
      @emit("connection", @channel) 
    @channel.onclose = ()=> 
      console.log("------- DC closed! -------")

    @channel.onerror = (err)=>
      console.error(err)

    @socket.removeAllListeners("wrtc.message")
    @socket.on 'wrtc.message', (msg)=>
      
      {type, sdp} = msg
      console.log type
      if type is "candidate"
        console.log(sdp)
        @pc.addIceCandidate(new RTCIceCandidate(sdp))
          .catch (err)->
            console.error(err)
      else if type is "answer"
        console.log 'running'
        @pc.setRemoteDescription(new RTCSessionDescription(sdp))
          .catch (err)->
            console.error(err);
        console.log("------ PROCESSED ANSWER ------");
      

  
  offer: ()->
    opts =       
      offerToReceiveAudio: false
      offerToReceiveVideo: true
    @pc.createOffer opts
      .then (sdp)=>        
        replaced = sdp.sdp.replace /a\=extmap\-allow\-mixed\r\n/, ''
        sdp.sdp = replaced
        @pc.setLocalDescription(sdp)
        @negotiate('offer', sdp);    
        console.log("------ SEND OFFER ------");
      .catch (err)=>      
        console.log(err)

  negotiate: (type, sdp)->
    params = 
      type: type
      sdp: sdp
    console.log "negotiate"
    @socket.emit "wrtc.message", params


  connect: ()->   
    @offer()
    return @channel

  close: ()->
    @pc?.close();
    @channel?.close();



module.exports = Peer


// WEBPACK FOOTER //
// ./src/component/device/remote/directive/peer.coffee